import { render } from "./ContactsRequisites.vue?vue&type=template&id=23b3475b&scoped=true"
import script from "./ContactsRequisites.vue?vue&type=script&lang=js"
export * from "./ContactsRequisites.vue?vue&type=script&lang=js"

import "./ContactsRequisites.vue?vue&type=style&index=0&id=23b3475b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b3475b"]])

export default __exports__